// Where the Terminal command line's history persists, and the one way to forget
// it. Its own module so `lib/sign-out.ts` (in the shell, on every page) can
// forget the history without importing the command line it belongs to.
//
// The key holds no user: it is this BROWSER's history. So sign-out forgets it —
// left alone, the next person at this browser pressed Up and read the previous
// user's commands (#5608 slice 17 row 23).

import { clearLocalPref } from '../local-pref';

export const COMMAND_HISTORY_KEY = 'dz-terminal-command-history';

/** Drop the persisted history. Called by `signOut` once the session is revoked. */
export function forgetCommandHistory(): void {
  clearLocalPref(COMMAND_HISTORY_KEY);
}
